export const environment = {
  production: false,
  entraId_clientId: '583ec7ef-e2ed-42e0-985c-f70845e4b46c',
  entraId_requireHttps: true,
  entraId_issuer: 'https://login.microsoftonline.com/972a3ea3-f979-4875-a2b8-cff001ab69e7/v2.0',

  data_url:'https://api.dev.rapidiv.myctca.net'
};
